import React, { Component } from 'react'
import PropTypes from 'prop-types'

class Image extends Component {
  render () {
    const {
      content
    } = this.props

    return (
      <img src={content} alt='Content Display' />
    )
  }
}

Image.propTypes = {
  content: PropTypes.string
}

export default Image



// WEBPACK FOOTER //
// ./src/components/contentDisplay/Image.js